import { render, staticRenderFns } from "./Contenteditable.vue?vue&type=template&id=73734bbe&scoped=true&"
import script from "./Contenteditable.vue?vue&type=script&lang=ts&"
export * from "./Contenteditable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73734bbe",
  null
  
)

export default component.exports